export const conversionNamespace = "conversion";

export const getConversionInputNamespace = (index: number) =>
  `conversion-input-${index}`;

export const isolationNamespace = "isolation";

export const harmonyInputNamespace = "harmony-input";

export const getHarmonyTrackNamespace = (index: number) => `harmony-${index}`;

export const mixedVoicesNamespace = "mixed-voices";

export const stemSplitNamespace = "stem-split-group";

export const getModelInputNamespace = (index: number) => `model-input-${index}`;
